<!-- *************************************************************************
TEMPLATE
************************************************************************* -->
<template>
  <div id="compos">
    <template v-if="currentViewBaked === 'loading'">
      <b-loading
        is-full-page
        :active.sync="isLoading"
      >
        <div class="box loading">
          <div class="bloader">
            <div class="shape shape-1" />
            <div class="shape shape-2" />
            <div class="shape shape-3" />
            <div class="shape shape-4" />
          </div>
        </div>
      </b-loading>
    </template>

    <div
      v-if="currentViewBaked === 'owner'"
      id="page_questioner"
      class="container"
    >
      <!-- <div id="ad_owner_1" /> -->
      <div class="box quizer">
        <center>
          <h3 id="que_quiz_name">
            <span id="page_que_subtitle">
              {{ $t('quiz.owner') }}
            </span>
          </h3>
        </center>
      </div>

      <!-- 728x90/320x50 waldo-tag-15165 -->
      <div id="ad-author-top" style="margin-bottom: 10px; text-align: center;"></div>

      <div
        v-if="quizData.answerers.length"
        class="box chart"
      >
        <center>
          <h4 class="scoreboard_title">
            {{ $t('quiz.top') }}
          </h4>
          <div class="scoreboard_questioner_container">
            <table class="scoreboard_questioner">
              <tbody>
                <tr>
                  <th id="page_que_name">
                    {{ $t('quiz.name') }}
                  </th>
                  <th id="page_que_score">
                    {{ $t('quiz.score') }}
                  </th>
                  <th id="page_que_view">
                    {{ $t('quiz.view') }}
                  </th>
                  <th id="page_que_delete">
                    {{ $t('quiz.delete') }}
                  </th>
                </tr>
                <template
                  v-for="answerer in answerersSorted"
                >
                  <tr
                    :key="answerer.id"
                    :class="'rank' + (answerer.score)"
                  >
                    <td>{{ answerer.name }}</td>
                    <td>{{ answerer.score }}</td>
                    <td class="view-td">
                      <button
                        class="view_results"
                        @click="send_to_answers(answerer.uid, qId)"
                      >
                        <i class="fas fa-stream" />
                      </button>
                    </td>
                    <td class="delete-td">
                      <button
                        class="option_remove_icon"
                        @click="delete_score(answerer.uid, qId)"
                      >
                        <i class="fas fa-trash" />
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </center>
      </div>
      <div
        v-else
        class="box chart chart_empty"
      >
        <center>
          <h4 class="scoreboard_title scoreboard_empty">
            {{ $t("quiz.nobody") }}
          </h4>
        </center>
      </div>
      <!-- <div id="ad_owner_2" /> -->
      <!-- 300x250 -->
      <!-- <div id="waldo-tag-15190" style="margin-bottom: 10px; text-align: center;"></div> -->

      <div class="box results">
        <center>
          <div class="quiz_ready_title">
            <h4>{{ $t("index.invite") }}</h4>
            <h2>{{ $t("index.ready") }}<span>{{ $t("index.live") }}</span></h2>
            <h3>{{ $t("index.goshare") }}</h3>
          </div>
        </center>

        <div class="quiz_link_container">
          <h4 id="results_quiz_link_title">
            {{ $t("index.quizlink") }}
          </h4>

          <input
            id="pollLinkField"
            v-model="quizLinkComp"
            type="text"
            size="35"
            class="highlighted_text"
            name="pollLinkField"
            readonly=""
          >

          <button
            id="copyButton"
            class="fullWidthButton button_2 pushdown"
            @click="copy_link()"
          >
            {{ $t("index.copylink") }}
          </button>
          <!-- <div class="copy_status_container"> -->
          <p
            v-if="display"
            id="status"
          >
            {{ $t("index.copied") }}
          </p>
          <!-- </div> -->
        </div>

        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button instagram_button"
              @click="show_how(1)"
            >
              <i class="fab fa-instagram" />
              <span
                id="instagram_share_button_text"
                class="share_text"
              >
                {{ $t("index.instagram") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button facebook_button"
              @click="goToFacebook()"
            >
              <i class="fab fa-facebook-f" />
              <span
                id="facebook_share_button_text"
                class="share_text"
              >
                {{ $t("index.facebook") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button twitter_button"
              @click="goToTwitter()"
            >
              <i class="fab fa-twitter" />
              <span
                id="twitter_share_button_text"
                class="share_text"
              >
                {{ $t("index.twitter") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button tiktok_button"
              @click="goToTiktok()"
            >
              <i class="fab fa-tiktok" />
              <span
                id="tiktok_share_button_text"
                class="share_text"
              >
                {{ $t("index.tiktok") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button whatsapp_button"
              @click="goToWhatsapp()"
            >
              <i class="fab fa-whatsapp" />
              <span
                id="whatsapp_share_button_text"
                class="share_text"
              >
                {{ $t("index.whatsapp") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button messenger_button"
              @click="goToMessenger()"
            >
              <i class="fab fa-facebook-messenger" />
              <span
                id="messenger_share_button_text"
                class="share_text"
              >
                {{ $t("index.messenger") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button whatsapp_button"
              @click="show_how(2)"
            >
              <i class="fab fa-whatsapp" />
              <span
                id="whatsapp_status_share_button_text"
                class="share_text"
              >
                {{ $t("index.whatsappstatus") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button snapchat_button last-in-box"
              @click="show_how(3)"
            >
              <i class="fab fa-snapchat-ghost" />
              <span
                id="snapchat_share_button_text"
                class="share_text"
              >
                {{ $t("index.snapchat") }}
              </span>
            </a>
          </div>
        </div>
      </div> <!-- closing div.box.results -->

      <!-- <div id="ad_owner_3" /> -->

      <div class="delete_button_shadow">
        <button
          id="delete_button_text"
          class="fullWidthButton button_2 pushdown"
          type="button"
          @click="deleteQuiz()"
        >
          {{ $t('index.deletebutton') }}
        </button>
      </div>

      <!-- Root element of PhotoSwipe. Must have class pswp. -->
      <div
        class="pswp"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="pswp__bg" />
        <div class="pswp__scroll-wrap">
          <div class="pswp__container">
            <div class="pswp__item" />
            <div class="pswp__item" />
            <div class="pswp__item" />
          </div>
          <div class="pswp__ui pswp__ui--hidden">
            <div class="pswp__top-bar">
              <div class="pswp__counter" />
              <button
                class="pswp__button pswp__button--close"
                title="Close (Esc)"
              />
              <button
                class="pswp__button pswp__button--share"
                title="Share"
              />
              <button
                class="pswp__button pswp__button--fs"
                title="Toggle fullscreen"
              />
              <button
                class="pswp__button pswp__button--zoom"
                title="Zoom in/out"
              />
              <div class="pswp__preloader">
                <div class="pswp__preloader__icn">
                  <div class="pswp__preloader__cut">
                    <div class="pswp__preloader__donut" />
                  </div>
                </div>
              </div>
            </div>
            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
              <div class="pswp__share-tooltip" />
            </div>
            <button
              class="pswp__button pswp__button--arrow--left"
              title="Previous (arrow left)"
            />
            <button
              class="pswp__button pswp__button--arrow--right"
              title="Next (arrow right)"
            />
            <div class="pswp__caption">
              <div class="pswp__caption__center" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- *************************************************************************
SCRIPT
************************************************************************* -->

<script>
import orderBy from 'lodash/orderBy'
import Vue from 'vue'
import RaptiveAds from '@/plugins/raptive.js';

export default {
  name: 'OwnerCompo',
  components: {
  },
  // eslint-disable-next-line
  props: [ 'quizData', 'qId', 'userId' ],
  data () {
    return {
      currentViewBaked: 'owner',
      copiedMessage: '',
      isLoading: false,
      display: false
      // playwireUnits: [
      //   {
      //     selectorId: 'ad_owner_1',
      //     type: 'leaderboard_atf'
      //   },
      //   {
      //     selectorId: 'ad_owner_2',
      //     type: 'leaderboard_atf'
      //   },
      //   {
      //     selectorId: 'ad_owner_3',
      //     type: 'med_rect_btf'
      //   },
      //   {
      //     type: 'left_rail'
      //   },
      //   {
      //     type: 'right_rail'
      //   }
      // ]
    }
  },
  computed: {
    answerersSorted () {
      return orderBy(this.quizData.answerers, ['score', 'name'], ['desc', 'asc'])
    },
    hasAnswerers () {
      if (this.quizData.answerers === undefined || this.quizData.answerers.length === 0) {
        return false
      } else {
        return true
      }
    },
    quizLinkComp: function () {
      return 'https://bestiefy.com/q?=' + this.qId
    }
  },
  watch: {
  },
  mounted () {
    Vue.use(RaptiveAds)
    // waldo.refreshTag('waldo-tag-15190')
    // waldo.refreshTag('waldo-tag-15165')
    // this.initTyche()
    const plugin = document.createElement('script')
    plugin.setAttribute(
      'src',
      '//cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.3/photoswipe.min.js'
    )
    plugin.async = true
    const pluginUi = document.createElement('script')
    pluginUi.setAttribute(
      'src',
      '//cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.3/photoswipe-ui-default.min.js'
    )
    document.head.appendChild(plugin)
    document.head.appendChild(pluginUi)
  },
  methods: {
    // initTyche () {
    //   // console.log('Tyche API@Owner is initialized')
    //   try {
    //     ramp.destroyUnits('all')
    //   } catch (e) {
    //     console.log('destroyUnits error: ', e)
    //   }
    //   ramp.addUnits(this.playwireUnits)
    //     .then(() => {
    //       ramp.displayUnits()
    //     // callback function
    //     }).catch((e) => {
    //       // catch errors
    //       console.log(e)
    //     })
    // },
    send_to_answers (answerer, qid) {
      // console.log(answerer)
      // console.log(qid)
      window.location.href = '/answers?q=' + qid + '?u=' + answerer
    },
    delete_score (answerer, qid) {
      let confirmationMessage = this.$t('quiz.confirmdeletion')
      let confirmation = confirm(confirmationMessage)
      if (confirmation === true) {
        this.currentViewBaked = 'loading'
        this.isLoading = true
        this.$http.all([
          this.$http.delete('https://bestiebackend.herokuapp.com/api/quizzes/' + answerer + '/' + qid),
          this.$http.delete('https://bestiebackend.herokuapp.com/api/users/' + qid + '/' + answerer)
        ])
          .then(response => {
            window.location.reload()
            // console.log(response)
          })
          .catch(error => {
            // console.log(error)
          })
      }
      // window.location.href = "https://bestiefy.com/results.html?q=" + pollID + "?u=" + scoreboard[_0xde79x3b][2]
    },
    copy_link () {
      let _0x2fcax7c
      let _0x2fcax7d
      let _0x2fcax7e = document.getElementById('pollLinkField')
      if (this.isOS()) {
        _0x2fcax7c = document.createRange()
        _0x2fcax7c.selectNodeContents(_0x2fcax7e)
        _0x2fcax7d = window.getSelection()
        _0x2fcax7d.removeAllRanges()
        _0x2fcax7d.addRange(_0x2fcax7c)
        _0x2fcax7e.setSelectionRange(0, 999999)
      } else {
        _0x2fcax7e.select()
      };
      document.execCommand('Copy')
      // this.copiedMessage = this.$t('index.copied')
      this.display = true
    },
    isOS () {
      return navigator.userAgent.match(/ipad|iphone/i)
    },
    goToFacebook () {
      window.open('https://facebook.com/sharer.php?u=https://bestiefy.com/q?=' + this.qId, '_blank')
    },
    goToWhatsapp () {
      let whatsappMessage = this.$t('index.gotowhatsapptwitter')
      window.location.href = 'whatsapp://send?text=' + whatsappMessage + ' https://bestiefy.com/q?=' + this.qId
    },
    goToMessenger () {
      window.location.href = 'fb-messenger://share/?link=https://bestiefy.com/q?=' + this.qId
    },
    goToTwitter () {
      let twitterMessage = this.$t('index.gotowhatsapptwitter')
      window.open('https://twitter.com/share?url=https://bestiefy.com/q?=' + this.qId + '&text=' + twitterMessage, '_blank')
    },
    // PhotoSwipe
    show_how (_platform) {
      var pswpElement = document.querySelectorAll('.pswp')[0]
      var howinstagram = [
        { src: 'https://webestiefy.com/bestimages/instructions_instagram_1.png',
          w: 360,
          h: 640
        },
        { src: 'https://webestiefy.com/bestimages/instructions_instagram_2.png',
          w: 360,
          h: 640
        }
      ]
      var howwhatsapp = [
        { src: 'https://webestiefy.com/bestimages/instructions_whatsapp_1.png',
          w: 360,
          h: 640
        },
        { src: 'https://webestiefy.com/bestimages/instructions_whatsapp_2.png',
          w: 360,
          h: 640
        }
      ]
      var howsnapchat = [
        { src: 'https://webestiefy.com/bestimages/instructions_snapchat_1.png',
          w: 360,
          h: 640
        },
        { src: 'https://webestiefy.com/bestimages/instructions_snapchat_2.png',
          w: 360,
          h: 640
        }
      ]
      var options = {
        history: false,
        tapToClose: true,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        bgOpacity: 0.7,
        showHideOpacity: true,
        counterEl: false,
        index: 0 // start at first slide
      }
      if (_platform === 1) {
        // eslint-disable-next-line
        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, howinstagram, options)
        gallery.init()
      } else if (_platform === 2) {
        // eslint-disable-next-line
        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, howwhatsapp, options)
        gallery.init()
      } else if (_platform === 3) {
        // eslint-disable-next-line
        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, howsnapchat, options)
        gallery.init()
      } else {}
    },
    // PhotoSwipe END
    deleteQuiz () {
      let confirmationMessage = this.$t('index.deleteconfirm')
      let confirmation = confirm(confirmationMessage)
      if (confirmation === true) {
        this.currentViewBaked = 'loading'
        this.isLoading = true
        this.$http.all([
          this.$http.delete('https://bestiebackend.herokuapp.com/api/quizzes/' + this.qId),
          this.$http.delete('https://bestiebackend.herokuapp.com/api/users/' + this.userId)
        ])
          .then(response => {
            window.location.href = '/'
            // console.log(response)
          })
          .catch(error => {
            // console.log(error)
          })
      }
    }
  }

}
</script>

<!-- *************************************************************************
STYLE
************************************************************************* -->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
